export default __webpack_public_path__ + "static/unimpressed-clear-3106473a281f75c987bcee11270a5bb3.png";